// dependancies
import React from "reactn";
import appHook from "../../../hooks/appHook";
import Validate from "./newUserDetailsRules";

// components
import UserInfoForm from "./user_info/userInfoForm";
import AddressWrapper from "./address/AddressWrapper";
import Button from "../../_common/Button/Button";
import UserProgress from "./progress/userProgress";

// styled components
import PageTitle from "../../_common/pageTitle/PageTitle.styled";
import SideContainer from "../../_common/containers/SideContainer";

const UserDetails = props => {
    const { history } = props;
    const submitForm = () => {
        history.push("/review");
    };
    const {
        handleChange,
        handleKeyup,
        handleBlur,
        handleSubmit,
        values,
        errors
    } = appHook(Validate, submitForm);

    return (
        <div className="grid-container">
            <UserProgress></UserProgress>
            <div className="flex--space-between">
                <SideContainer>
                    <PageTitle className="color--grey-d">
                        Your new details
                        </PageTitle>
                    <UserInfoForm
                        handleChange={handleChange}
                        handleKeyup={handleKeyup}
                        handleBlur={handleBlur}
                        values={values}
                        errors={errors}
                    />
                    <AddressWrapper
                        handleChange={handleChange}
                        handleKeyup={handleKeyup}
                        handleBlur={handleBlur}
                        values={values}
                        errors={errors}
                    ></AddressWrapper>

                    {/* Desktop submit */}
                    <Button
                        className="bn bn--primary gtm-linkclick"
                        onClick={() => {
                            handleSubmit();
                        }}
                        type="button"
                        text="Continue"
                    />
                </SideContainer>

            </div>
        </div>
    );
};

export default UserDetails;
